import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';

import * as surveyActions from 'actions/surveyActions';

import { getPropertyPublicForShowings } from 'actions/landlordPropertiesActions';
import * as bookingActions from 'actions/bookingsActions';

import styled from 'styled-components';
import DrawerFooter from 'components/ui/DrawerFooter';
import CreateShowingDrawerSearchStep from 'components/landlord_app/showings/CreateShowingDrawerSearchStep';
import CreateShowingDetailsStepOnlineBooking from 'components/bookings/CreateShowingDetailsStepOnlineBooking';
import CtaPrimary from 'components/ui/CtaPrimary';
import Row from 'components/ui/Row';

import errorAnimationData from 'assets/error.json';
import loadingAnimationData from 'assets/loading.json';
import successAnimationData from 'assets/success.json';

import { getTranslatedString } from 'helpers/i18n';
import DrawerSuccessMessages from 'components/ui/DrawerSuccessMessages';
import Lottie from 'react-lottie';

import MediaQuery from 'react-responsive';

const SLOT_SEARCH_STEP = 'slot_search';
const DETAILS_STEP = 'details';
const FORM_NAME = 'showing_form';

const Page = styled.div`
  display: ${props => `${props.show ? 'block' : 'none'}`};
`;

const StyledHeaderRow = styled(Row)`
  margin-bottom: 10px;
`;

const StyledShowingSelectionContainer = styled.div`
  margin-top: 32px;
  padding: ${props => (props.messageContainer ? '24px 44px' : '24px 44px 44px')};

  border-radius: 24px;
  width: 580px;
  background-color: white;
  border-bottom-right-radius: ${props => (props.messageContainer ? '24px' : '0')};
  border-bottom-left-radius: ${props => (props.messageContainer ? '24px' : '0')};
  text-align: initial;

  max-height: 60%;
  overflow-y: auto;

  @media (max-width: 650px) {
    width: 100%;
    max-height: 100%;
    height: calc(100% - 188px);
    overflow-y: scroll;
  }

  ${props => props.messageContainer && `padding: 0;`};
`;

const StyledButtonContainer = styled.div`
  background-color: white;
  border-radius: 24px;
  padding: 0 16px;
  width: 580px;
  border-top-right-radius: 0;
  border-top-left-radius: 0;

  @media (max-width: 650px) {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0;
  }
`;

export default connect(
  store => {
    return {
      showSuccessfulVerificationMessage: store.survey.showSuccessfulVerificationMessage,
      showLoader: store.survey.showLoader,
      property: store.landlordProperties.property,
      isLoading: store.bookings.isLoading,
      bookingError: store.bookings.showBookingError,
      bookingErrorMessages: store.bookings.errorMessage,
      showSelectBooking: store.bookings.select_availability,
      timeAvailability: store.bookings.timeAvailability,
      bookingDetails: store.bookings.bookingDetails,
      collectLeadDetailsForm: store.bookings.collectLeadDetails,
      bookingConfirmed: store.bookings.bookingConfirmed,
      accentColor: store.userTypes.accentColor,
      googleTagId: store.userTypes.googleTagId,
    };
  },
  {
    ...surveyActions,
    getPropertyPublicForShowings,
    ...bookingActions,
  }
)(
  class BookShowing extends Component {
    constructor(props) {
      super(props);
      this.state = {
        activeStep: SLOT_SEARCH_STEP,
        slotSearchData: undefined,
        loading: false,
        error: false,
        success: false,
        formData: {},
      };
    }

    componentDidMount() {
      const query_params = browserHistory.getCurrentLocation().query;
      if (query_params && query_params.property_id) {
        this.props.getPropertyPublicForShowings(query_params.property_id);
      } else {
        browserHistory.push('/dashboard');
      }
    }

    submitBookingTimesForm = vars => {
      this.props.setToIsLoading();
      this.props.removePreviousSearchResults();
      this.props.getApartmentAvailability(
        browserHistory.getCurrentLocation().query.property_id,
        vars.time,
        vars.date,
        vars.unit_type,
        true
      );
    };

    collectLeadDetails = (time, date) => {
      this.props.collectLeadDetails(
        browserHistory.getCurrentLocation().query.property_id,
        time,
        date
      );
    };

    handleBack = () => {
      this.setState({
        activeStep: SLOT_SEARCH_STEP,
      });
    };

    setRef = ref => (this.overviewContainer = ref);

    goNextStep = () => {
      const { activeStep } = this.state;
      if (activeStep === SLOT_SEARCH_STEP) {
        // A delay is required becuase otherwize it re-renders before primary action click event is handled
        // as a result, the form in the next step is submitted immediately after first render
        setTimeout(() => {
          this.setState({
            activeStep: DETAILS_STEP,
          });
          this.overviewContainer.scrollIntoView({
            block: 'start',
            behaviour: 'smooth',
          });
        }, 0);
      }
    };

    setSlotSearchData = data => {
      this.setState({
        slotSearchData: data,
      });
    };

    handleLoadingChange = options => {
      this.setState({
        loading: options.loading || false,
        error: options.error || false,
        formData: options.formData,
      });
    };

    handleSubmissionComplete = formData => {
      this.setState({
        loading: false,
        success: true,
        formData: formData,
      });
    };

    render() {
      if (this.state.success) {
        return this.renderSuccess(this.state.formData.full_name);
      } else if (this.state.loading) {
        return this.renderLoading();
      } else if (this.state.error) {
        return this.renderError(this.state.formData.full_name);
      } else {
        return this.renderFormWizard();
      }
    }

    renderFormWizard = () => {
      const { activeStep, slotSearchData, loading } = this.state;
      return (
        <React.Fragment>
          <StyledShowingSelectionContainer>
            {this.renderHeader()}
            {this.renderSubheader()}
            <Page show={activeStep === SLOT_SEARCH_STEP}>{this.renderSearchStep()}</Page>
            {activeStep === DETAILS_STEP && this.renderDetailsStep()}
          </StyledShowingSelectionContainer>
          <StyledButtonContainer>
            <DrawerFooter
              primaryActionFormName={activeStep === DETAILS_STEP ? FORM_NAME : undefined}
              primaryActionText={
                loading
                  ? getTranslatedString('showingDrawer.loading')
                  : activeStep === SLOT_SEARCH_STEP
                    ? getTranslatedString('showingDrawer.continue')
                    : getTranslatedString('showingDrawer.confirmAndBook')
              }
              onPrimaryActionClick={activeStep === SLOT_SEARCH_STEP ? this.goNextStep : undefined}
              primaryActionDisabled={!slotSearchData || loading}
            />
          </StyledButtonContainer>
        </React.Fragment>
      );
    };

    renderHeader = () => {
      if (this.state.activeStep !== SLOT_SEARCH_STEP) return;

      return (
        <StyledHeaderRow>
          <MediaQuery query="(max-device-width: 750px)">
            <h4>We look forward to welcoming you to our community</h4>
          </MediaQuery>
          <MediaQuery query="(min-device-width: 749px)">
            <h3>We look forward to welcoming you to our community</h3>
          </MediaQuery>
        </StyledHeaderRow>
      );
    };

    renderSubheader = () => {
      if (!this.props.property.virtual_tour) return;

      return (
        <StyledHeaderRow>
          <p>{getTranslatedString('showingDrawer.weUnderstandButItsVirtual')}</p>
        </StyledHeaderRow>
      );
    };

    renderSuccess = fullName => {
      const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: successAnimationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      };

      return (
        <StyledShowingSelectionContainer messageContainer>
          <DrawerSuccessMessages
            headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
            headerText={getTranslatedString('showingDrawer.showingSuccessfullyBooked')}
            bodyText={getTranslatedString('showingDrawer.welcomeToCommunityConfirmation')}
            background="white"
          />
        </StyledShowingSelectionContainer>
      );
    };

    renderError = fullName => {
      const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: errorAnimationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      };

      return (
        <StyledShowingSelectionContainer messageContainer>
          <DrawerSuccessMessages
            headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
            headerText={getTranslatedString('globalDrawer.errorHeader', {
              name: getTranslatedString('this.showing'),
            })}
            bodyText={getTranslatedString('globalDrawer.errorBody')}
            cta={
              <CtaPrimary onClick={() => this.setState({ error: false })}>
                {getTranslatedString('globalDrawer.goBack')}
              </CtaPrimary>
            }
            background="white"
          />
        </StyledShowingSelectionContainer>
      );
    };

    renderLoading = () => {
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingAnimationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      };

      return (
        <StyledShowingSelectionContainer messageContainer>
          <DrawerSuccessMessages
            headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
            headerText={getTranslatedString('globalDrawer.loadingHeader', {
              object: getTranslatedString('showing'),
            })}
            bodyText={getTranslatedString('globalDrawer.loadingBody')}
            background="white"
          />
        </StyledShowingSelectionContainer>
      );
    };

    renderSearchStep = () => {
      return (
        <CreateShowingDrawerSearchStep
          property={this.props.property}
          unitTypes={this.props.property.unit_types}
          setSlotSearchData={this.setSlotSearchData}
          isProspect
          maxHeight="270px"
          hideTitle
        />
      );
    };

    renderDetailsStep = () => {
      return (
        <CreateShowingDetailsStepOnlineBooking
          property={this.props.property}
          slotSearchData={this.state.slotSearchData}
          trafficSources={this.props.property.traffic_sources}
          formName={FORM_NAME}
          onLoadingChange={this.handleLoadingChange}
          onSubmissionComplete={this.handleSubmissionComplete}
          handleBack={this.handleBack}
          setRef={this.setRef}
        />
      );
    };
  }
);
